import WrapPage from "../components/wrapPage"
import Projects from "../projectsPage"

export default WrapPage(Projects)
